// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"ReviewSummaryAvatars_avatarContainer__7ZneY","avatar":"ReviewSummaryAvatars_avatar__UQVvB"};